import { render } from "./Tenant_Balances.vue?vue&type=template&id=c08babb6"
import script from "./Tenant_Balances.vue?vue&type=script&lang=js"
export * from "./Tenant_Balances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__